import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { usePage, useForm, router } from '@inertiajs/react'

import { Card } from '@material-tailwind/react'
import { toast } from 'react-toastify'
import Chart from 'react-apexcharts'

import Layout from '@/Shared/Layout'
import TrashedMessage from '@/Shared/TrashedMessage'
import BreadCrumbs from '@/Shared/BreadCrumbs'

import Form from '@/Pages/Users/Shared/Form'

const Edit = () => {
    const { user, chartDates, chartData, chartCount } = usePage().props

    const { data, setData, errors, post, processing } = useForm({
        name: user.name,
        email: user.email,
        password: '',
        password_confirmation: '',
        role: user.role,
        hospital_id: user.hospital_id || null,

        // NOTE: When working with Laravel PUT/PATCH requests and FormData
        // you SHOULD send POST request and fake the PUT request like this.
        _method: 'PUT'
    })

    const series = [
        {
            name: 'Items',
            data: chartCount
        },
        {
            name: 'Consumeds',
            data: chartData
        }
    ]

    const options = {
        colors: ['#86efac', '#fcd34d'],
        chart: {
            height: 400,
            type: 'line',
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        title: {
            text: 'Consumeds Item Quantity Last Month',
            align: 'left'
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            }
        },
        xaxis: {
            categories: chartDates
        }
    }

    useEffect(() => {
        Object.values(errors).map(error => {
            toast.error(error)
        })
    }, [errors])

    function handleSubmit(e) {
        e.preventDefault()

        // NOTE: We are using POST method here, not PUT/PACH. See comment above.
        post(route('users.update', user.id))
    }

    function destroy() {
        if (confirm('Are you sure you want to delete this user?')) {
            router.delete(route('users.destroy', user.id))
        }
    }

    function restore() {
        if (confirm('Are you sure you want to restore this user?')) {
            router.put(route('users.restore', user.id))
        }
    }

    return (
        <div>
            <Helmet title={`${data.name}`} />

            <BreadCrumbs link="users" title="Users" subTitle="Edit" />

            <h1 className="mb-8 text-3xl font-bold">Edit {data.name}</h1>

            <Card className="p-4">
                <Chart
                    options={options}
                    series={series}
                    type="bar"
                    height="500"
                    className="mt-4"
                />
            </Card>

            {user.deleted_at && (
                <TrashedMessage onRestore={restore}>
                    This user has been deleted.
                </TrashedMessage>
            )}

            <div className="max-w-3xl overflow-y-visible rounded bg-white p-8 shadow mt-4">
                <h1 className="text-2xl font-semibold">User Form</h1>

                <Form
                    data={data}
                    errors={errors}
                    processing={processing}
                    setData={setData}
                    handleSubmit={handleSubmit}
                    isEdit
                    deleted_at={user.deleted_at}
                    destroy={destroy}
                />
            </div>
        </div>
    )
}

Edit.layout = page => <Layout children={page} />

export default Edit
